/**
 * Platform default when an org has not set `organizations.app_display_name`.
 * Used for UI copy, webhook source labels, and similar fallbacks — not the internal repo/codename.
 */
export const PLATFORM_DEFAULT_APP_DISPLAY_NAME = "Turbo Assist";
